module.exports = __webpack_public_path__ + "assets/img/detail1.f5958835.png";